import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "victory-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "The test is complete", -1)
const _hoisted_3 = {
  key: 0,
  class: "tada"
}
const _hoisted_4 = {
  key: 1,
  class: "not-tada"
}

import SpecialButton from '../SpecialButton/SpecialButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VictoryScreen',
  props: {
    numCorrectAnswers: {},
    totalAcronyms: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", null, " You scored " + _toDisplayString(props.numCorrectAnswers) + " out of " + _toDisplayString(props.totalAcronyms), 1),
    (props.numCorrectAnswers === props.totalAcronyms)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 🎉🎉🎉 "))
      : _createCommentVNode("", true),
    (props.numCorrectAnswers < props.totalAcronyms)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, " 😔 better luck next time! "))
      : _createCommentVNode("", true),
    _createVNode(SpecialButton, {
      inverted: true,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clear-game')))
    }, {
      default: _withCtx(() => [
        _createTextVNode("Play again?")
      ]),
      _: 1
    })
  ]))
}
}

})